<script>
import ListView from '../base/ListView.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ListView,
  },
  computed: mapGetters({
    deletedItem: 'taxrate/del/deleted',
    error: 'taxrate/list/error',
    items: 'taxrate/list/items',
    isLoading: 'taxrate/list/isLoading',
    view: 'taxrate/list/view'
  }),

  created () {
    this.$store.dispatch('taxrate/list/setFilter', {company: this.$route.params.company})
  },

  methods: {
    ...mapActions({
      getPage: 'taxrate/list/default'
    }),
    createTaxRate () {
      return {name: 'TaxRateCreate', params: { company: this.$route.params.company }}
    }
  }
}
</script>
<template>
  <list-view store="taxrate" :add-route="createTaxRate" edit-route="TaxRateUpdate">
    <template v-slot:header="slotProps">
      <b-col md="2"><strong>{{ $t('taxrate.name.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('taxrate.taxRate.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('taxrate.validFrom.label') }}</strong></b-col>
      <b-col md="2"><strong>{{ $t('taxrate.validTo.label') }}</strong></b-col>
    </template>
    <template v-slot:item="slotProps">
      <b-col md="2">{{ slotProps.item.name }}</b-col>
      <b-col md="2">{{ slotProps.item.taxRate }}</b-col>
      <b-col md="2">{{ slotProps.item.validFrom }}</b-col>
      <b-col md="2">{{ slotProps.item.validTo }}</b-col>
      <b-col md="2"></b-col>
    </template>
    <template v-slot:buttons="slotProps">
    </template>
  </list-view>
</template>
